import humps from 'humps';
import api from 'services/api';
import get from 'lodash/get';
import { selectCurrentWorkspace } from 'store/Faraday/selectors';
import { selectActiveFeeds, selectCommandHistory } from 'store/Dashboard/selectors';
import { DASHBOARD_FILTERS, CONFIRMED_FLAG_FILTERS, CLOSED_FILTERS, RISK_TAGS } from 'store/Filters/constants';
import { isFilteringBy } from 'store/Filters/selectors';

export const GET_VULNS_COUNT = 'GET_VULNS_COUNT';
export const GET_VULNS_COUNT_SUCCEED_DASHBOARD = 'GET_VULNS_COUNT_SUCCEED_DASHBOARD';
export const GET_VULNS_COUNT_FAILURE_DASHBOARD = 'GET_VULNS_COUNT_FAILURE_DASHBOARD';

export const GET_TOP_SERVICES = 'GET_TOP_SERVICES';
export const GET_TOP_SERVICES_FAILURE_DASHBOARD = 'GET_TOP_SERVICES_FAILURE_DASHBOARD';
export const GET_TOP_SERVICES_SUCCEED_DASHBOARD = 'GET_TOP_SERVICES_SUCCEED_DASHBOARD';

export const GET_TOP_HOSTS = 'GET_TOP_HOSTS';
export const GET_TOP_HOSTS_FAILURE_DASHBOARD = 'GET_TOP_HOSTS_FAILURE_DASHBOARD';
export const GET_TOP_HOSTS_SUCCEED_DASHBOARD = 'GET_TOP_HOSTS_SUCCEED_DASHBOARD';

export const GET_SUMMARY_DASHBOARD = 'GET_SUMMARY_DASHBOARD';
export const GET_SUMMARY_SUCCEED_DASHBOARD = 'GET_SUMMARY_SUCCEED_DASHBOARD';
export const GET_SUMMARY_FAILURE_DASHBOARD = 'GET_SUMMARY_FAILURE_DASHBOARD';

export const GET_ACTIVITY_FEED = 'GET_ACTIVITY_FEED';
export const GET_ACTIVITY_FEED_SUCCEED_DASHBOARD = 'GET_ACTIVITY_FEED_SUCCEED_DASHBOARD';
export const GET_ACTIVITY_FEED_FAILURE_DASHBOARD = 'GET_ACTIVITY_FEED_FAILURE_DASHBOARD';
export const GET_ACTIVITY_FEED_CANCELLED_DASHBOARD = 'GET_ACTIVITY_FEED_CANCELLED_DASHBOARD';

export const GET_COMMAND_HISTORY_START = 'GET_COMMAND_HISTORY_START';
export const GET_COMMAND_HISTORY_SUCCEED = 'GET_COMMAND_HISTORY_SUCCEED';
export const GET_COMMAND_HISTORY_FAILURE = 'GET_COMMAND_HISTORY_FAILURE';

export const GET_TIMELINE = 'GET_TIMELINE';
export const GET_TIMELINE_SUCCEED_DASHBOARD = 'GET_TIMELINE_SUCCEED_DASHBOARD';
export const GET_TIMELINE_FAILURE_DASHBOARD = 'GET_TIMELINE_FAILURE_DASHBOARD';

export const GET_LATEST_VULNS_START_DASHBOARD = 'GET_LATEST_VULNS_START_DASHBOARD';
export const GET_LATEST_VULNS_SUCCEED_DASHBOARD = 'GET_LATEST_VULNS_SUCCEED_DASHBOARD';
export const GET_LATEST_VULNS_FAILURE_DASHBOARD = 'GET_LATEST_VULNS_FAILURE_DASHBOARD';

export const GET_LATEST_TAGS_START_DASHBOARD = 'GET_LATEST_TAGS_START_DASHBOARD';
export const GET_LATEST_TAGS_SUCCEED_DASHBOARD = 'GET_LATEST_TAGS_SUCCEED_DASHBOARD';
export const GET_LATEST_TAGS_FAILURE_DASHBOARD = 'GET_LATEST_TAGS_FAILURE_DASHBOARD';

export const GET_LATEST_COMMENTS_START_DASHBOARD = 'GET_LATEST_COMMENTS_START_DASHBOARD';
export const GET_LATEST_COMMENTS_SUCCEED_DASHBOARD = 'GET_LATEST_COMMENTS_SUCCEED_DASHBOARD';
export const GET_LATEST_COMMENTS_FAILURE_DASHBOARD = 'GET_LATEST_COMMENTS_FAILURE_DASHBOARD';

export const GET_VULNS_BY_STATUS_REQUEST = 'GET_VULNS_BY_STATUS_REQUEST';
export const GET_VULNS_BY_STATUS_SUCCESS = 'GET_VULNS_BY_STATUS_SUCCESS';
export const GET_VULNS_BY_STATUS_FAILURE = 'GET_VULNS_BY_STATUS_FAILURE';

export const GET_VULNS_BY_SEVERITY_REQUEST = 'GET_VULNS_BY_SEVERITY_REQUEST';
export const GET_VULNS_BY_SEVERITY_SUCCESS = 'GET_VULNS_BY_SEVERITY_SUCCESS';
export const GET_VULNS_BY_SEVERITY_FAILURE = 'GET_VULNS_BY_SEVERITY_FAILURE';

export const SHOW_MODAL_IMPORT_DASHBOARD = 'SHOW_MODAL_IMPORT_DASHBOARD';

export const RELOAD_FEED = 'RELOAD_FEED';

export const GET_STATS_FILTERED_START = 'GET_STATS_FILTERED_START';
export const GET_STATS_FILTERED_SUCCESS = 'GET_STATS_FILTERED_SUCCESS';
export const GET_STATS_FILTERED_FAILURE = 'GET_STATS_FILTERED_FAILURE';

export const GET_WS_STATS_START = 'GET_WS_STATS_START';
export const GET_WS_STATS_SUCCESS = 'GET_WS_STATS_SUCCESS';

export const RESET_WORKSPACE_STATS = 'RESET_WORKSPACE_STATS';

export const GET_RISK_TAG_COUNTS_REQUEST = 'GET_RISK_TAG_COUNTS_REQUEST';
export const GET_RISK_TAG_COUNTS_SUCCESS = 'GET_RISK_TAG_COUNTS_SUCCESS';
export const GET_RISK_TAG_COUNTS_FAILURE = 'GET_RISK_TAG_COUNTS_FAILURE';

const getVulnsCountFailureCallback = (error) => ({
  type: GET_VULNS_COUNT_FAILURE_DASHBOARD, error
});

const getVulnsCountSuccedCallback = (data) => ({
  type: GET_VULNS_COUNT_SUCCEED_DASHBOARD, data
});

export function getVulnsCount () {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_VULNS_COUNT });
      const workspace = selectCurrentWorkspace(getState());

      const response = await api.dashboard.getVulnsCountBySeverity(workspace);
      return dispatch(getVulnsCountSuccedCallback(response));
    } catch (e) {
      return dispatch(getVulnsCountFailureCallback(get(e, 'message', 'An error has occurred.')));
    }
  };
}

export function getTopServices () {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_TOP_SERVICES });
      const workspace = selectCurrentWorkspace(getState());
      const response = await api.dashboard.getTopServicesByName(workspace);
      return dispatch({ type: GET_TOP_SERVICES_SUCCEED_DASHBOARD, data: response });
    } catch (e) {
      return dispatch({ type: GET_TOP_SERVICES_FAILURE_DASHBOARD, error: e.message || 'An error has occurred.' });
    }
  };
}

// getTopHosts() is the single source for "top hosts" data — it used to be
// duplicated as fetchTopAssetsByVulns() (same endpoint, same cache, a
// module-level mutex to dedup the two). Both the legacy TopHosts widget and
// the FindingsByAsset widget now call this one action directly instead of
// relying on a parent container to prefetch it for them.
// The isFetchingTopHosts flag below is enough to dedupe two widgets mounting
// together without any extra module-level lock: dispatch() runs the reducer
// synchronously, so the flag is already true in the store by the time a
// second, later call reads getState() — even with no `await` in between.
export function getTopHosts () {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const workspace = selectCurrentWorkspace(state);
      const cache = state.dashboard?.cache?.topAssets;
      const now = Date.now();
      const TTL = 5 * 60 * 1000;

      if (state.dashboard?.isFetchingTopHosts) return Promise.resolve();
      if (cache && cache.workspace === workspace && (now - cache.timestamp) < TTL) {
        return Promise.resolve();
      }

      dispatch({ type: GET_TOP_HOSTS });
      const response = await api.dashboard.getTopHostsDashboard(workspace);
      return dispatch({ type: GET_TOP_HOSTS_SUCCEED_DASHBOARD, data: response, cache: { workspace, timestamp: now, ttl: TTL } });
    } catch (e) {
      return dispatch({ type: GET_TOP_HOSTS_FAILURE_DASHBOARD, error: e.message || 'An error has occurred.' });
    }
  };
}

export function getSummary () {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_SUMMARY_DASHBOARD });
      const workspace = selectCurrentWorkspace(getState());
      const response = await api.workspace.getWsStats(workspace);
      return dispatch({ type: GET_SUMMARY_SUCCEED_DASHBOARD, data: response });
    } catch (e) {
      return dispatch({ type: GET_SUMMARY_FAILURE_DASHBOARD, error: e.message || 'An error has occurred.' });
    }
  };
}

const riskTagCountQuery = (filter, extraFilters) => ({ limit: 1, offset: 0, filters: [filter, ...extraFilters] });

const countFromSettledResult = (result) => (result.status === 'fulfilled' ? get(result, 'value.count', 0) : 0);

export function getRiskTagCounts () {
  return async (dispatch, getState) => {
    const requestId = crypto.randomUUID();
    try {
      dispatch({ type: GET_RISK_TAG_COUNTS_REQUEST, requestId });
      const state = getState();
      const workspace = selectCurrentWorkspace(state);
      const { confirmed } = CONFIRMED_FLAG_FILTERS;
      const { closed } = CLOSED_FILTERS;
      const extraFilters = [
        ...(isFilteringBy(state, 'vulns', confirmed) ? [confirmed] : []),
        ...(isFilteringBy(state, 'vulns', closed) ? [closed] : [])
      ];

      const results = await Promise.allSettled([
        api.manage.newGetVulns(workspace, riskTagCountQuery(DASHBOARD_FILTERS.vulnsByTag(RISK_TAGS.cisaKev), extraFilters)),
        api.manage.newGetVulns(workspace, riskTagCountQuery(DASHBOARD_FILTERS.vulnsByTag(RISK_TAGS.exploitAvailable), extraFilters)),
        api.manage.newGetVulns(workspace, riskTagCountQuery(DASHBOARD_FILTERS.vulnsByTag(RISK_TAGS.trending), extraFilters))
      ]);

      const [cisaKevRes, exploitAvailableRes, trendingRes] = results;
      const rejected = results.filter((result) => result.status === 'rejected');

      if (rejected.length === results.length) {
        return dispatch({
          type: GET_RISK_TAG_COUNTS_FAILURE,
          requestId,
          error: get(rejected, '[0].reason.message', 'An error has occurred.')
        });
      }

      return dispatch({
        type: GET_RISK_TAG_COUNTS_SUCCESS,
        requestId,
        data: {
          cisaKev: countFromSettledResult(cisaKevRes),
          exploitAvailable: countFromSettledResult(exploitAvailableRes),
          trending: countFromSettledResult(trendingRes)
        }
      });
    } catch (e) {
      return dispatch({ type: GET_RISK_TAG_COUNTS_FAILURE, requestId, error: get(e, 'message', 'An error has occurred.') });
    }
  };
}

const getLatestVulnsStartCallback = (data) => ({
  type: GET_LATEST_VULNS_START_DASHBOARD,
  data
});

const getLatestVulnsSuccedCallback = (data) => ({
  type: GET_LATEST_VULNS_SUCCEED_DASHBOARD,
  data
});

const getLatestVulnsFailureCallback = (error) => ({
  type: GET_LATEST_VULNS_FAILURE_DASHBOARD,
  error
});

export function getLatestVulns (confirmed) {
  return async (dispatch, getState) => {
    try {
      dispatch(getLatestVulnsStartCallback());
      const workspace = selectCurrentWorkspace(getState());
      const queryParam = { offset: 0, limit: 5, order_by: [{ field: 'create_date', direction: 'desc' }] };
      const filters = [{ name: 'confirmed', op: '==', val: 'true' }];
      let newQuery = queryParam;
      if (confirmed) newQuery = Object.assign(queryParam, { filters });
      const response = await api.manage.newGetVulns(workspace, newQuery);
      return dispatch(getLatestVulnsSuccedCallback(humps.camelizeKeys(response)));
    } catch (e) {
      return dispatch(getLatestVulnsFailureCallback(get(e, 'message', 'Failed to obtain latest vulns')));
    }
  };
}

const getLatestTagsStartCallback = (data) => ({
  type: GET_LATEST_TAGS_START_DASHBOARD,
  data
});

const getLatestTagsSuccedCallback = (data) => ({
  type: GET_LATEST_TAGS_SUCCEED_DASHBOARD,
  data
});

const getLatestTagsFailureCallback = (error) => ({
  type: GET_LATEST_TAGS_FAILURE_DASHBOARD,
  error
});

export function getLatestTags () {
  return async (dispatch, getState) => {
    try {
      dispatch(getLatestTagsStartCallback());
      const workspace = selectCurrentWorkspace(getState());
      const response = await api.dashboard.fetchLatestTags(workspace);
      return dispatch(getLatestTagsSuccedCallback(response));
    } catch (e) {
      return dispatch(getLatestTagsFailureCallback(e));
    }
  };
}

const getLatestCommentsStartCallback = (data) => ({
  type: GET_LATEST_COMMENTS_START_DASHBOARD,
  data
});

const getLatestCommentsSuccedCallback = (data) => ({
  type: GET_LATEST_COMMENTS_SUCCEED_DASHBOARD,
  data
});

const getLatestCommentsFailureCallback = (error) => ({
  type: GET_LATEST_COMMENTS_FAILURE_DASHBOARD,
  error
});

export function getLatestComments () {
  return async (dispatch, getState) => {
    try {
      dispatch(getLatestCommentsStartCallback());
      const workspace = selectCurrentWorkspace(getState());
      const response = await api.dashboard.fetchLatestComments(workspace);
      return dispatch(getLatestCommentsSuccedCallback(response));
    } catch (e) {
      return dispatch(getLatestCommentsFailureCallback(e));
    }
  };
}

export function getActivityFeed (page = 1) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ACTIVITY_FEED });
      const ws = selectCurrentWorkspace(getState());
      const feeds = selectActiveFeeds(getState());

      const response = await api.dashboard.getActivitiesList(ws, page);

      if (selectCurrentWorkspace(getState()) !== ws) {
        return dispatch({ type: GET_ACTIVITY_FEED_CANCELLED_DASHBOARD });
      }

      const parsed = response.activities;
      const showMore = response.show_more === undefined ? parsed.length === 16 : response.show_more;

      const data = page === 1 ? parsed : [...feeds.activities, ...parsed];

      return dispatch({
        type: GET_ACTIVITY_FEED_SUCCEED_DASHBOARD,
        data: {
          activities: [...data],
          showMore
        }
      });
    } catch (e) {
      return dispatch({ type: GET_ACTIVITY_FEED_FAILURE_DASHBOARD, error: e.message || 'An error has occurred.' });
    }
  };
}

export function getCommandHistory (page = 1) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_COMMAND_HISTORY_START });

      const ws = selectCurrentWorkspace(getState());
      const history = selectCommandHistory(getState());

      const response = await api.dashboard.getCommandHistory(ws, page);
      const parsed = response.commands.map((c) => c.value);
      const hasMore = parsed.length === api.dashboard.COMMAND_HISTORY_PAGE_SIZE;

      const data = page === 1 ? parsed : [...history, ...parsed];

      dispatch({ type: GET_COMMAND_HISTORY_SUCCEED, data, hasMore });
    } catch (e) {
      dispatch({ type: GET_COMMAND_HISTORY_FAILURE, error: e.message || 'An error has occurred.' });
    }
  };
}

export function getTimeline () {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_TIMELINE });
      const workspace = selectCurrentWorkspace(getState());
      const response = await api.dashboard.getVulnsTimeline(workspace);
      return dispatch({ type: GET_TIMELINE_SUCCEED_DASHBOARD, data: response });
    } catch (e) {
      return dispatch({ type: GET_TIMELINE_FAILURE_DASHBOARD, error: e.message || 'An error has occurred.' });
    }
  };
}
export function showModalImportDashboard (value) {
  return (dispatch) => {
    dispatch({ type: SHOW_MODAL_IMPORT_DASHBOARD, value });
  };
}

export function refreshDashboard () {
  return (dispatch) => {
    dispatch({ type: RELOAD_FEED });
  };
}

export function onGetVulnsByStatusFail (e) {
  return (dispatch) => {
    dispatch({ type: GET_VULNS_BY_STATUS_FAILURE, error: e });
  };
}

export function getVulnsCountByStatus (filterParams = '') {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const workspace = selectCurrentWorkspace(state);
      const { isFetchingVulnsByStatus } = state.dashboard;
      const cache = state.dashboard?.cache?.vulnCountByStatus;
      const now = Date.now();
      const TTL = 5 * 60 * 1000;

      if (isFetchingVulnsByStatus) return;

      if (cache && cache.workspace === workspace && cache.filterParams === filterParams && cache.timestamp && (now - cache.timestamp) < TTL) {
        return Promise.resolve();
      }

      dispatch({ type: GET_VULNS_BY_STATUS_REQUEST });

      const response = await api.dashboard.getVulnsCountByStatus(workspace, filterParams);
      const hasData = response?.groups?.length > 0;
      return dispatch({ type: GET_VULNS_BY_STATUS_SUCCESS, data: response, cache: hasData ? { timestamp: now, workspace, filterParams } : undefined });
    } catch (e) {
      return dispatch(onGetVulnsByStatusFail(get(e, 'message', 'Failed to obtain Vuln count by Status.')));
    }
  };
}

export function onGetVulnsBySeverityFail (e) {
  return (dispatch) => {
    dispatch({ type: GET_VULNS_BY_SEVERITY_FAILURE, error: e });
  };
}

export function getVulnsCountBySeverity (filterParams = '') {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const workspace = selectCurrentWorkspace(state);
      const { isFetchingVulnsBySeverity } = state.dashboard;
      const cache = state.dashboard?.cache?.vulnCountBySeverity;
      const now = Date.now();
      const TTL = 5 * 60 * 1000;

      if (isFetchingVulnsBySeverity) return Promise.resolve();

      // Remediation and BySeverity both need this data and each fetch it on
      // their own mount (no widget waits on a sibling for it) — the cache key
      // includes filterParams so both only dedupe into one request when they
      // actually agree on the same confirmed/closed filters.
      if (cache && cache.workspace === workspace && cache.filterParams === filterParams && (now - cache.timestamp) < TTL) {
        return Promise.resolve();
      }

      dispatch({ type: GET_VULNS_BY_SEVERITY_REQUEST });
      const response = await api.dashboard.getVulnsCountBySeverity(workspace, filterParams);
      const hasData = response?.groups?.length > 0;
      return dispatch({ type: GET_VULNS_BY_SEVERITY_SUCCESS, data: response, cache: hasData ? { workspace, filterParams, timestamp: now } : undefined });
    } catch (e) {
      return dispatch(onGetVulnsBySeverityFail(get(e, 'message', 'Failed to obtain Vuln count by Severity.')));
    }
  };
}

export function getStatsFiltered (filter) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_STATS_FILTERED_START });
      const workspace = selectCurrentWorkspace(getState());
      const response = await api.workspace.getWsStatsFiltered(workspace, filter);
      return dispatch({ type: GET_STATS_FILTERED_SUCCESS, data: response });
    } catch (e) {
      return dispatch({ type: GET_STATS_FILTERED_FAILURE, error: e.message || 'Failed to obtain filtered stats.' });
    }
  };
}

export const resetWsStats = () => (dispatch) => dispatch({ type: RESET_WORKSPACE_STATS });

export const GET_PENTEST_STATUS_REQUEST = 'GET_PENTEST_STATUS_REQUEST';
export const GET_PENTEST_STATUS_SUCCESS = 'GET_PENTEST_STATUS_SUCCESS';
export const GET_PENTEST_STATUS_FAILURE = 'GET_PENTEST_STATUS_FAILURE';

export const GET_RISK_POSTURE_REQUEST = 'GET_RISK_POSTURE_REQUEST';
export const GET_RISK_POSTURE_SUCCESS = 'GET_RISK_POSTURE_SUCCESS';
export const GET_RISK_POSTURE_FAILURE = 'GET_RISK_POSTURE_FAILURE';

export const GET_NEW_SERVICES_REQUEST = 'GET_NEW_SERVICES_REQUEST';
export const GET_NEW_SERVICES_SUCCESS = 'GET_NEW_SERVICES_SUCCESS';
export const GET_NEW_SERVICES_FAILURE = 'GET_NEW_SERVICES_FAILURE';

export const GET_NEW_ASSETS_REQUEST = 'GET_NEW_ASSETS_REQUEST';
export const GET_NEW_ASSETS_SUCCESS = 'GET_NEW_ASSETS_SUCCESS';
export const GET_NEW_ASSETS_FAILURE = 'GET_NEW_ASSETS_FAILURE';

export const GET_FOUND_VS_CLOSED_TIMELINE_REQUEST = 'GET_FOUND_VS_CLOSED_TIMELINE_REQUEST';
export const GET_FOUND_VS_CLOSED_TIMELINE_SUCCESS = 'GET_FOUND_VS_CLOSED_TIMELINE_SUCCESS';
export const GET_FOUND_VS_CLOSED_TIMELINE_FAILURE = 'GET_FOUND_VS_CLOSED_TIMELINE_FAILURE';

export function fetchPentestStatus () {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const workspace = selectCurrentWorkspace(state);
      const cache = state.dashboard?.cache?.pentestStatus;
      const now = Date.now();
      const TTL = 5 * 60 * 1000;

      if (cache && cache.timestamp && (now - cache.timestamp) < TTL) {
        return Promise.resolve();
      }

      dispatch({ type: GET_PENTEST_STATUS_REQUEST });
      const response = await api.dashboard.fetchPentestStatus(workspace);
      return dispatch({ type: GET_PENTEST_STATUS_SUCCESS, data: response, cache: { timestamp: now, ttl: TTL } });
    } catch (e) {
      return dispatch({ type: GET_PENTEST_STATUS_FAILURE, error: get(e, 'message', 'Failed to fetch pentest status.') });
    }
  };
}

export function fetchRiskPosture () {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const workspace = selectCurrentWorkspace(state);
      const cache = state.dashboard?.cache?.riskPosture;
      const now = Date.now();
      const TTL = 5 * 60 * 1000;

      if (cache && cache.timestamp && (now - cache.timestamp) < TTL) {
        return Promise.resolve();
      }

      dispatch({ type: GET_RISK_POSTURE_REQUEST });
      const statsResponse = await api.workspace.getWsStats(workspace);
      return dispatch({ type: GET_RISK_POSTURE_SUCCESS, data: statsResponse, cache: { timestamp: now, ttl: TTL } });
    } catch (e) {
      return dispatch({ type: GET_RISK_POSTURE_FAILURE, error: get(e, 'message', 'Failed to fetch risk posture.') });
    }
  };
}

export function fetchNewServices (limit = 5) {
  return async (dispatch, getState) => {
    try {
      const workspace = selectCurrentWorkspace(getState());
      dispatch({ type: GET_NEW_SERVICES_REQUEST });
      const response = await api.dashboard.fetchNewServices(workspace, limit);
      return dispatch({ type: GET_NEW_SERVICES_SUCCESS, data: response });
    } catch (e) {
      return dispatch({ type: GET_NEW_SERVICES_FAILURE, error: get(e, 'message', 'Failed to fetch new services.') });
    }
  };
}

export function fetchNewAssets (limit = 5) {
  return async (dispatch, getState) => {
    try {
      const workspace = selectCurrentWorkspace(getState());
      dispatch({ type: GET_NEW_ASSETS_REQUEST });
      const response = await api.dashboard.fetchNewAssets(workspace, limit);
      return dispatch({ type: GET_NEW_ASSETS_SUCCESS, data: response });
    } catch (e) {
      return dispatch({ type: GET_NEW_ASSETS_FAILURE, error: get(e, 'message', 'Failed to fetch new assets.') });
    }
  };
}

export function fetchFoundVsClosedTimeline (days = 15) {
  return async (dispatch, getState) => {
    try {
      const workspace = selectCurrentWorkspace(getState());
      dispatch({ type: GET_FOUND_VS_CLOSED_TIMELINE_REQUEST });
      const response = await api.dashboard.fetchFoundVsClosedTimeline(workspace, days);
      return dispatch({ type: GET_FOUND_VS_CLOSED_TIMELINE_SUCCESS, data: response });
    } catch (e) {
      return dispatch({ type: GET_FOUND_VS_CLOSED_TIMELINE_FAILURE, error: get(e, 'message', 'Failed to fetch found vs closed timeline.') });
    }
  };
}
